import { render, staticRenderFns } from "./SocialContactButton.vue?vue&type=template&id=3e3439b3&scoped=true&"
import script from "./SocialContactButton.vue?vue&type=script&lang=ts&"
export * from "./SocialContactButton.vue?vue&type=script&lang=ts&"
import style0 from "./SocialContactButton.vue?vue&type=style&index=0&id=3e3439b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3439b3",
  null
  
)

export default component.exports